import "./../css/Footer.css";
import versionData from "./Version";

function Footer() {
const version = versionData[0].version;
const releaseDate = versionData[0].releaseDate;

  return (
    <footer className="footer">
      <div className="footer-container">
        <p>&copy; {releaseDate} </p>
           <p>V{version}</p>
        
      </div>
    </footer>
  );
}

export default Footer;
